import styled from 'styled-components'

import backgroundImage from '@/assets/images/background.png'

export const HeroWrapper = styled.div`
  max-width: 1200px;
  margin: 120px auto;
  text-align: center;
  padding: 0 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1000px;
    height: 1000px;
    filter: blur(100px);
    z-index: -1;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: -2;
    pointer-events: none;
  }
`

export const Title = styled.h1`
  max-width: 668px;
  font-size: 72px;
  line-height: 1.1;
  margin-bottom: 24px;
  color: #000;
  font-weight: 500;
  letter-spacing: -0.02em;
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export const Description = styled.p`
  font-size: 20px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 48px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`

export const CTAButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;

  .btn {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      inset: -2px;
      border-radius: 100px;
      background: linear-gradient(45deg, rgba(0, 255, 255, 0.5), rgba(64, 144, 255, 0.5), rgba(157, 78, 221, 0.5));
      filter: blur(10px);
      z-index: -1;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover::after {
      opacity: 1;
    }
  }
`

export const PrimaryButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  border: none;
  border-radius: 100px;
  background: #18181b;
  color: white;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: #000;
    transform: translateY(-2px);
  }

  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`
